import axios from "axios";

export default {
    acceptInvitation: async (invitationHash, microsoftToken) => {
        await axios.post(`/invitation/accept/`, {
            invitation_hash: invitationHash,
            microsoft_token: microsoftToken
        })
    },
    signupInvitation: async(data) => {
        await axios.post(`/invitation/signup/`, data)
    }
}
